import { isBefore, subYears } from "date-fns";
import { Client } from "../types";
import { isNRI } from "./client";

function needsReKyc(client: Client) {
  const kycDate = client.kyc_status_date;
  const isKycOlderThan2Years =
    kycDate != null && isBefore(new Date(kycDate), subYears(new Date(), 2));
  return isKycOlderThan2Years;
}

type KycState =
  | "not-started"
  | "in-progress"
  | "under-process"
  | "must-validate"
  | "re-kyc"
  | "failed"
  | "complete";

export function getKycState(client: Client): KycState {
  if (client.kyc_status_remark === "KYC Validated") return "complete";

  if (client.kyc_status_remark === "KYC REGISTERED") {
    if (isNRI(client)) return "complete";
    if (!needsReKyc(client)) return "must-validate";
  }

  if (
    client.hyperverge_kyc_application_status === "needs_review" ||
    client.hyperverge_kyc_application_status === "manually_approved" ||
    client.hyperverge_kyc_application_status === "auto_approved"
  ) {
    return "under-process";
  }
  if (
    client.hyperverge_kyc_application_status === "manually_declined" ||
    client.hyperverge_kyc_application_status === "auto_declined"
  ) {
    return "failed";
  }

  if (client.hyperverge_kyc_application_status === "user_cancelled") {
    return "in-progress";
  }

  if (client.kyc_status_remark === "KYC REGISTERED") {
    return "re-kyc";
  }

  if (client.kyc_status_remark === "UNDER_PROCESS") {
    return "under-process";
  }

  if (client.kyc_status_remark === "KYC REJECTED") {
    return "failed";
  }

  return "not-started";
}
